const doc = [({"da":({"js":({"merfoto":({"layout":({"topbar":({"index":({"basket":"Indkøbskurv"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;